import React from "react"
import ReactDOM from "react-dom"
import Notification from "./notification"

export default class NotificationModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.classModifier = elem.dataset.classModifier
    self.version = elem.dataset.version
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<Notification {...self.modelJson} version={self.version} modifier={self.classModifier} />, self.elem)
  }
}
